import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationApi } from '@/Domain/api/Conversation/Conversation.api';

export const useGetConversation = (conversationId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: [Endpoint.conversation.get, conversationId],
    queryFn: () => ConversationApi.get(conversationId),
    staleTime: 0,
  });

  return {
    conversation: data,
    isLoading,
  };
};
